import axios from 'axios';
import {baseUrl} from './constants/constants'

const instance = axios.create({
    baseURl:baseUrl,
});

export default instance